import {createSlice} from '@reduxjs/toolkit';

import {
  builderGetDailyChartReport,
  builderGetDelayChartReport,
  builderGetOrders,
  builderGetProducts,
  builderGetVendorReports
} from './reducer';

const initialState: any = {
  getReportsError: '',
  isloadingReports: false,
  reports: {},

  isloadingDailyChartReports: false,
  getDailyChartReportsError: '',
  chartReports: {},

  isloadingDelayChartReports: false,
  getDelayChartReportsError: '',
  chartDelayReports: {},

  getOrdersLoading: false,
  getOrdersError: '',
  orders: [],
  pagination: {},

  getOrdersProductsLoading: false,
  getOrdersProductsError: '',
  ordersProducts: []
};

export const reportSlicer = createSlice({
  name: 'report',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    //get number of total sales
    builderGetVendorReports(builder);
    //get chart data
    builderGetDailyChartReport(builder);
    builderGetDelayChartReport(builder);
    //get orders
    builderGetOrders(builder);
    builderGetProducts(builder);
  }
});

export default reportSlicer.reducer;
